/*
  * Used for changing the state or data
*/
import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import * as _ from 'lodash';
import { http } from '@/shared/https';
Vue.use(Vuex, Axios);

export default {
    /*
        * Load initial data
    */
    load: ({ commit, dispatch }, payload) => {
        if(payload.actions == undefined || payload.actions.listAction == undefined) {
            return
        }

        //#. Create form event - reset properties 
        if (payload.dashboard.componentId == 0) {
            payload.disabled = false;
            payload.formEdit = true;
        }
        payload.loading = true;
        if (payload.card && payload.card.report == true) {
            if (payload.dashboard.extraParams == null)
                payload.dashboard.extraParams = 0;
        }

        if (localStorage.extraParams != null && localStorage.extraParams != "")
            payload.dashboard.extraParams = localStorage.getItem('extraParams');

        let dashboardId = (payload.dashboard.componentId == "" ? null : payload.dashboard.componentId);
        let params = '';
        if (dashboardId) {
            params = dashboardId;

            if (payload.dashboard.extraParams) {
                params += '/' + payload.dashboard.extraParams;
            }
        }

        return http.get(payload.actions.listAction + params).then(record => {
            let result = record.data;

            //#.Access denied 404
            if (record.data.Result == undefined) {
                payload.accessDeny = true;
                payload.showInputs = false;
                payload.loading = false;
                payload.renderTable = false;
                payload.renderTitleComponent = false;
                return;
            }

            //#.Render header, boody and footer information based on the settings
            if (record.data.Result == 'OK') {
                payload.accessDeny = false;
                payload.showInputs = true;
                payload.loading = true;
                payload.renderTable = true;
                payload.renderTitleComponent = true;
                dispatch('render', { payload, result });
            } else {
                commit('_logError', { payload: payload, message: record.data.Message, action: 'load >' });
            }
        });
    },

    /*
       * Render header, boody and footer information based on the settings
   */
    render: ({ commit, dispatch }, context) => {
        if (context.payload.org) {
            context.payload.orgFields = context.payload.org;
        }

        context.payload.data = [];
        _.forOwn(context.result.Record, function (obj, index) {
            context.payload.data[index] = {};
            _.forOwn(obj, function (val, name) {
                context.payload.data[index][name] = val;
            });
        });

        commit('_muDownload', { payload: context.payload, result: context.result, commit, dispatch });
        commit('_muRenderTitle', { payload: context.payload, result: context.result });
        commit('_muRender', { payload: context.payload, result: context.result });
        context.payload.loading = false;
    },

    /*
        * Create new records to the server and updates table.
    */
    Create: ({ commit, dispatch }, payload) => {
        if (!payload.context.ajaxFormSubmit) {
            payload.record = payload.context.editedItem["FormData"];
            payload.context.contentHeader = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        }

        return http.post(payload.createActions, payload.record).then(record => {
            let result = record.data, context = payload.context;

            if (record.data.Result == 'OK') {
                result.operations = 1;

                if (payload.context.inlineEditor.enabled) {
                    payload.context.editedIndexArray = [];
                    payload.context.editedItem[payload.keyField] = record.data.Record[payload.keyField];
                    payload.context.formData[payload.context.editedIndex][payload.keyField] = record.data.Record[payload.keyField];

                    //#.Reset hidden and readonly fields value.
                    payload.context.fields.filter(x => x.type == 'Hidden').forEach(key => {
                        if (record.data.Record[key.value])
                            payload.context.formData[payload.context.editedIndex][key.value] = record.data.Record[key.value];
                    });

                    if (payload.context.tempData.length > 0) {
                        //#.Temporarily store the new records
                        delete payload.context.tempData[payload.context.tempData.indexOf(payload.context.editedItem)];
                        payload.context.tempData.length = 0;
                    }

                    //#.Reset edit index
                    payload.context.editedIndex = null;

                    //#.Auto create an empty row if inline editor empty row annotation is enabled
                    if (payload.context.inlineEditor.enabled && payload.context.inlineEditor.emptyRow) {
                        let defaultRowData = {};
                        payload.context.isDirty = false;

                        //#.Reset all the default values in fields
                        payload.context.fields.filter(x => x.list != false && x.type != 'Hidden').forEach(key => {
                            defaultRowData[key.value] = payload.context.defaultItem[key.value];

                            if (key.displayCurrentDate) {
                                return;
                            }

                            if (payload.context.defaultItem[key.value] && !key.defaultValue)
                                defaultRowData[key.value] = null;
                        });

                        //#.Adding empty row to records based on pagination
                        let emptyRowTempData = [];

                        _.forOwn(payload.context.formData, function (key, val) {
                            if (payload.context.pagination.pageSize != -1 && payload.context.pagination.pageSize - 1) {
                                if (payload.context.formData.length > (payload.context.pagination.pageSize - 1)) {
                                    // @ts-ignore
                                    if ((payload.context.pagination.pageSize - 1) == val) {
                                         // @ts-ignore
                                        emptyRowTempData.push(defaultRowData);
                                    }
                                     // @ts-ignore
                                    emptyRowTempData.push(key);
                                }
                            }
                        });

                        //#.Temporarily store the new records
                        payload.context.tempData.push(defaultRowData);
                    
                        //#.Newly added records pused to form data
                        if (payload.context.pagination.pageSize == -1 || (payload.context.formData.length <= (payload.context.pagination.pageSize - 1))) {
                            payload.context.formData.push(defaultRowData);
                        } else {
                            payload.context.formData = emptyRowTempData;
                        }

                        //#.Enable the disabled save button
                        payload.context.buttonDisabled = false;

                        //#.Index of empty row
                        payload.context.emptyRowIndex = context.formData.indexOf(defaultRowData);

                        //#.Check if the new record index
                        payload.context.editedIndex = context.formData.indexOf(defaultRowData);
                        payload.context.editedIndexArray.push(context.editedIndex);
                        payload.context.data.push(record.data.Record);

                        //#.formCreated event raising methods
                        dispatch(payload.context.fileName + '/formCreated', payload.context);
                    }
                }

                if (payload.context.dialog) {
                    payload.item[payload.keyField] = record.data.Record[payload.keyField];

                    //#. Reset hidden and readonly fields value.
                    payload.context.fields.filter(x => x.type == 'Hidden').forEach(key => {
                        if (record.data.Record[key.value])
                            payload.item[key.value] = record.data.Record[key.value];
                    });

                    payload.context.formData.push(payload.item);
                    payload.context.data.push(record.data.Record);

                    if (typeof (payload.saveAndContinue) != 'object' && payload.saveAndContinue)
                        dispatch('add', { context: payload.context, self: payload.self }, { root: true });
                    else
                        payload.context.dialog = false;

                } else {
                    payload.context.disabled = true;
                    payload.context.formEdit = false;
                    //#.Enable the disabled save button
                    payload.context.buttonDisabled = false;

                    //#. Create form event - reset properties 
                    if (window.location.hash == "#0") {
                        payload.context.editedItem[payload.keyField] = record.data.Record[payload.keyField];
                        payload.root.componentId = record.data.Record[payload.keyField];
                        context.dashboard.componentId = record.data.Record[payload.keyField];
                        payload.context.mapItem = payload.context.editedItem;

                        //#.URL state reset
                        history.pushState({
                            id: ''
                        }, '', window.location.href.substr(0, window.location.href.indexOf('#') + 1) + payload.root.componentId);

                        if (payload.context.titleSearch) {
                            let fieldName = payload.context.orginTitle.substr(2).slice(0, -2);
                            payload.context.mapItem[fieldName] = record.data.Record[fieldName];
                            payload.context.dashboard.appTitle = record.data.Record[fieldName];

                            if (payload.context.parentComponent
                                && payload.context.profile
                                && payload.context.profile.enabled
                                && payload.context.profile.fields.length > 0) {

                                let title = payload.context.mapItem[fieldName];

                                _.forOwn(payload.context.profile.fields, function (val, index) {
                                    if (payload.context.profile.fields.indexOf(val) != -1) {
                                        if (payload.context.orgFields[val].type == 'ComboBox') {
                                            title = (title == null) ? payload.context.mapItem[val].DisplayText : (title + (payload.context.mapItem[val].DisplayText == undefined ? "" : payload.context.profile.separator + payload.context.mapItem[val].DisplayText));
                                        } else {
                                            title = (title == null) ? payload.context.mapItem[val] : (title + (payload.context.mapItem[val] == "" ? "" : payload.context.profile.separator + payload.context.mapItem[val]));
                                        }
                                    }
                                });
                                payload.context.dashboard.appTitle = title;
                            }
                        }
                    }
                }

                //#. Get all the permitted step the corresponding step. 
                if (payload.context.parentComponent && payload.context.workflow.workflowImplemented) {
                    dispatch(payload.context.workflow.actions.updateAction, { result, context });
                }

                if (payload.context.card.type == payload.context.type._form) {
                    payload.context.editedIndex = -1;
                }

                dispatch(payload.context.fileName + '/recordCreated', { result, context });
                commit('_muCRUDNotificaion', { result });
                payload.context.isDirty = false;
            } else {
                payload.context.buttonDisabled = false;
                payload.context.formCreate = true;

                var messageCol = '',
                    message = null,
                    delemeter = '@#',
                    fieldName = null;
                messages = result.Message.toString();
                var spliter = '</br>',
                    messages = messages.split(spliter),
                    count = messages.length;
                if (count > 1) {
                    result.operations = 5;
                    for (var i = 0; i < count; i++) {
                        try {
                            message = messages[i].split(delemeter);
                            if (message)
                                message = message[1];

                            if (message) {
                                if(payload.self)
                                    messageCol += (i + 1) + '. ' + (payload.self.$vuetify.lang.locales[payload.self.$vuetify.lang.current][message] || message) + spliter;
                                else
                                    messageCol += (i + 1) + '. ' + message + spliter;
                            }
                        } catch (e) {
                            continue;
                        }
                    }

                    result.Message = messageCol;
                }
                else {
                    result.operations = 4;
                }
                commit('_muCRUDNotificaion', { result });
            }
        });
    },

    /*
        * Update existing records to the server and updates table.
    */
    Update: ({ commit, dispatch }, payload) => {
        if (!payload.context.ajaxFormSubmit) {
            payload.record = payload.context.editedItem["FormData"];
            payload.context.contentHeader = {
                'Content-Type': 'multipart/form-data'
            }
        }

        return http.put(payload.updateActions, payload.record).then(record => {
            let result = record.data, context = payload.context;

            if (record.data.Result == 'OK') {
                //#. Get all the permitted step the corresponding step. 
                if (payload.context.parentComponent && payload.context.workflow.workflowImplemented) {
                    dispatch(payload.context.workflow.actions.updateAction, { result, context });
                }

                if (payload.context.dialog) {
                    payload.context.renderTable = false;

                    //#. Reset hidden and readonly fields value.
                    payload.context.fields.filter(x => x.type == 'Hidden' || x.readonly === true).forEach(key => {
                        if (record.data.Record[key.value])
                            payload.item[key.value] = record.data.Record[key.value];
                    });

                    payload.context.formData[payload.index] = payload.item;
                    payload.context.data[payload.index] = payload.record;

                    Vue.nextTick(() => {
                        //#. Add the component back in
                        payload.context.renderTable = true;
                    });
                }

                if (payload.context.inlineEditor.enabled) {
                    payload.context.data[payload.context.editedIndex] = record.data.Record;

                    if (payload.context.inlineEditor.autoSave) {
                        if (payload.context.formData.indexOf(payload.item) == payload.context.copyEditedIndex) {
                            payload.context.editedIndex = null;
                        } else {
                            if (payload.context.copyEditedIndex != null)
                                payload.context.editedIndexArray.push(payload.context.copyEditedIndex);

                            payload.context.editedIndex = payload.context.copyEditedIndex;
                        }
                    } else {
                        payload.context.editedIndex = null;
                    }

                    payload.context.isDirty = false;
                }

                payload.context.mapItem = payload.context.editedItem;

                if (payload.context.titleSearch) {
                    let fieldName = payload.context.orginTitle.substr(2).slice(0, -2);
                    payload.context.mapItem[fieldName] = record.data.Record[fieldName];
                    payload.context.dashboard.appTitle = record.data.Record[fieldName];

                    if (payload.context.parentComponent
                        && payload.context.profile
                        && payload.context.profile.enabled) {

                        let title = payload.context.mapItem[payload.context.orginTitle.substr(2).slice(0, -2)];

                        _.forOwn(payload.context.profile.fields, function (val, index) {
                            if (payload.context.profile.fields.indexOf(val) != -1) {
                                if (payload.context.orgFields[val].type == 'ComboBox' && payload.context.mapItem[val] && typeof (payload.context.mapItem[val]) == "object") {
                                    title = (title == null) ? payload.context.mapItem[val].DisplayText : (payload.context.mapItem[val].DisplayText == undefined ? title : title + payload.context.profile.separator + payload.context.mapItem[val].DisplayText);
                                }
                                else if (payload.context.orgFields[val].type == 'ComboBox') {
                                    title = (title == null) ? ((payload.context.mapItem[val] == null || payload.context.mapItem[val] == "") ? "" : payload.context.mapItem[val]) : ((payload.context.mapItem[val] == "" || payload.context.mapItem[val] == null) ? title : title + payload.context.profile.separator + payload.context.mapItem[val]);
                                } else {
                                    title = (title == null) ? payload.context.mapItem[val] : (title + ((payload.context.mapItem[val] == "" || payload.context.mapItem[val] == null) ? "" : payload.context.profile.separator + payload.context.mapItem[val]));
                                }
                            }
                        });
                        payload.context.dashboard.appTitle = title;
                    }
                }

                result.operations = 2;
                payload.context.disabled = true;
                payload.context.formEdit = false;

                if (payload.context.card.type == payload.context.type._form) {
                    payload.context.editedIndex = -1;
                }

                dispatch(payload.context.fileName + '/recordUpdated', { result, context });
                commit('_muCRUDNotificaion', { result });
                payload.context.dialog = false;
                payload.context.isDirty = false;
            } else {

                if (payload.context.inlineEditor.enabled && payload.context.inlineEditor.autoSave) {
                    payload.context.editedIndex = payload.context.formData.indexOf(payload.item);
                    payload.context.editedItem = context.copyEditedItem;
                }

                payload.context.buttonDisabled = false;

                var messageCol = '',
                    message = null,
                    delemeter = '@#',
                    fieldName = null;
                messages = result.Message.toString();
                var spliter = '</br>',
                    messages = messages.split(spliter),
                    count = messages.length;
                if (count > 1) {
                    result.operations = 5;
                    for (var i = 0; i < count; i++) {
                        try {
                            message = messages[i].split(delemeter);
                            if (message)
                                message = message[1];

                                 if (message) {
                                     if (payload.self) {
                                         messageCol += (i + 1) + '. ' + (payload.self.$vuetify.lang.locales[payload.self.$vuetify.lang.current][message] || message) + spliter;
                                     } else {
                                         messageCol += (i + 1) + '. ' + message + spliter;
                                     }
                                  }
                             } catch (e) {
                                 continue;
                             }
                         }
                       
                       result.Message=messageCol;
                     }
                     else{
                         result.operations = 4;
                     }
                     commit('_muCRUDNotificaion', { result });
            }
        });
    },

    /*
        * Delete exisitng records to the server and updates table.
    */
    Delete: ({ commit, dispatch }, payload) => {
        return http.delete(payload.deleteActions + payload.id).then(record => {

            let result = record.data, context = payload.context;
            if (record.data.Result == 'OK') {
                payload.context.data = payload.context.data.slice(0, payload.index);
                payload.context.formData.splice(payload.index, 1);
                result.operations = 3;

                if (payload.context.inlineEditor.enabled && payload.context.inlineEditor.emptyRow) {
                    if (payload.index < payload.context.emptyRowIndex) {
                        payload.context.emptyRowIndex = payload.context.emptyRowIndex - 1;
                    }
                }

                if (payload.context.card.type != payload.context.type._formLabelLeft && payload.context.card.type != payload.context.type._formLabelRight) {
                    payload.context.renderTable = false;

                    Vue.nextTick(() => {
                        //#. Add the component back in
                        payload.context.renderTable = true;
                    });
                }

                dispatch(payload.context.fileName + '/recordDeleted', { result, context });
                commit('_muCRUDNotificaion', { result });
            } else {
                dispatch('dashboard/enableNotify', { color: 'error', text: result.Message });
            }
        }).catch(error => {
        });
    }
}